import { render, staticRenderFns } from "./BusinessConsumer.vue?vue&type=template&id=588793f0"
import script from "./BusinessConsumer.vue?vue&type=script&lang=js"
export * from "./BusinessConsumer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports